<template>
    <div>
        <UiComponentTypography tag="h5"> {{ filter }}</UiComponentTypography>
        <div class="mt-4" v-if="options?.length">
            <div class="mx-auto" :style="grindLvlRangeStyle" v-if="options?.length > 1">
                <URange :min="0" :max="options?.length - 1" v-model="selectedGrindIndex" />
            </div>
            <ul class="flex gap-4 text-center mt-2">
                <li
                    class="cursor-pointer"
                    :class="selectedGrindIndex === index ? 'font-bold text-amazon-500' : 'text-gray-700'"
                    v-for="(item, index) in options"
                    :style="grindLvlStyle"
                    @click="handleChangeGrindLvl(index)"
                >
                    <div class="flex flex-col justify-center items-center text-xs group">
                        <UiIconSvgs v-if="item" class-name="w-12 h-12" :name="(item as keyof typeof CoffeeMachines)" />
                        <div class="relative -top-3 opacity-0 group-hover:opacity-100 group-hover:top-0 transition-all">
                            {{ CoffeeMachines[item as keyof typeof CoffeeMachines] }}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
const activeVariant = defineModel({ type: String });

const emits = defineEmits(["update"]);

const props = defineProps({
    options: {
        type: Array as PropType<string[]>,
    },
    filter: {
        type: String,
        default: "",
    },
    deactivateIndexes: {
        type: Array,
    },
});

const selectedGrindIndex = computed({
    get() {
        if (activeVariant.value) return props.options?.findIndex((item) => item === activeVariant.value) as number;
        else return 0;
    },
    set(v: number) {
        emits("update", { [props.filter]: activeVariant.value }, { [props.filter]: props.options?.[v] });
        activeVariant.value = props.options?.[v];
    },
});

const grindLvlStyle = computed(() => {
    return {
        width: 100 / (props.options?.length ?? 2) + "%",
    };
});

const grindLvlRangeStyle = computed(() => {
    return {
        width: 100 - 100 / (props.options?.length ?? 2) + 4 + "%",
    };
});

function handleChangeGrindLvl(index: number) {
    selectedGrindIndex.value = index;
}

// type machinesType = "drip" | "espresso" | "french-press" | "moka-pot" | "turkish" | "airopress" | "chemex";

const CoffeeMachines = {
    "french-press": "فرنچ پرس",
    drip: "دریپ",
    chemex: "کمکس",
    airopress: "ایروپرس",
    "moka-pot": "موکاپاد",
    espresso: "اسپرسو",
    turkish: "جزوه",
};
</script>

<style></style>
